import { render, staticRenderFns } from "./GetCode.vue?vue&type=template&id=c43d6c52"
import script from "./GetCode.vue?vue&type=script&lang=js"
export * from "./GetCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports